// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__OLpw7","footer":"ModalError_footer__3cgjA"};